import {Button, Modal} from "react-bootstrap";
import ImageComponent from "../shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import profileImage from "../../../images/profileImage.png";
import {Field, Formik} from "formik";
import * as Yup from "yup";
import {useAddReview} from "../../../hooks/useReview";
import {showToastModal} from "../shared/ToastModalSwal";

const AvisModal = ({openModal, toggleModal, intervention}) => {
  const {onAddReview} = useAddReview();

  const handleReviewSubmit = async (values) => {
    // Add your review submission logic here
    onAddReview({
      comment: values.comment,
      rating: values.rating,
      createdForId: intervention?.Offer_Proposal?.Technician?.User?.id,
      interventionId: intervention?.id,
    });
    toggleModal(false);
  };
  return (
    <Modal
      className="modal fade"
      show={openModal}
      onHide={() => {
        toggleModal(false);
        showToastModal({
          title: "Intervention finalisée",
          message: "L'intervention a été finalisée avec succès.",
          success: true,
        });
      }}
      centered
      size="md"
    >
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title text-[#1A64B9] font-semibold">
            Ajouter un avis
          </h4>
          <Button
            variant=""
            type="button"
            className="close"
            onClick={() => {
              toggleModal(false);
              showToastModal({
                title: "Intervention finalisée",
                message: "L'intervention a été finalisée avec succès.",
                success: true,
              });
            }}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body !py-3 !px-0 h-fit max-h-[70vh] overflow-scroll overflow-style-none">
          <div className="w-full flex flex-col justify-center items-center gap-2 ">
            <div className="flex flex-col justify-center items-center ">
              <ImageComponent
                src={buildImageUrl(
                  intervention?.Offer_Proposal?.Technician?.User?.imageUri,
                )}
                alt="User"
                className="w-16 aspect-square rounded-full object-cover"
                fallback={
                  <img
                    src={profileImage}
                    alt="User"
                    className="w-16 aspect-square rounded-full object-cover"
                  />
                }
              />
              <div className="text-base font-semibold text-[#19295C] capitalize">
                {intervention?.Offer_Proposal?.Technician?.User?.lastName}{" "}
                {intervention?.Offer_Proposal?.Technician?.User?.firstName}
              </div>
              <div
                className="text-base font-normal  
                "
              >
                {intervention?.title}{" "}
              </div>
            </div>

            <Formik
              initialValues={{rating: 0, comment: ""}}
              validationSchema={Yup.object({
                rating: Yup.number()
                  .required("Le rating est requis")
                  .min(1, "Le rating doit être au moins 1")
                  .max(5, "Le rating ne peut pas dépasser 5"),
                comment: Yup.string()
                  .required("Le commentaire est requis")
                  .min(5, "Le commentaire doit contenir au moins 5 caractères"),
              })}
              onSubmit={handleReviewSubmit}
            >
              {({values, errors, touched, handleSubmit, setFieldValue}) => (
                <form onSubmit={handleSubmit} className="w-full">
                  <div className="w-full !px-6 !py-3">
                    <div className="form-group mb-4">
                      <div className="flex w-full justify-center items-center gap-2">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <button
                            type="button"
                            key={star}
                            onClick={() => setFieldValue("rating", star)}
                            className={`text-4xl ${
                              values.rating >= star
                                ? "text-yellow-400"
                                : "text-gray-300"
                            }`}
                          >
                            ★
                          </button>
                        ))}
                      </div>
                      {errors.rating && touched.rating && (
                        <div className="text-red-500 text-sm mt-1">
                          {errors.rating}
                        </div>
                      )}
                    </div>

                    <div className="form-group mb-4">
                      <Field
                        as="textarea"
                        rows={3}
                        className="form-control placeholder:text-sm"
                        name="comment"
                        placeholder="Votre commentaire ici..."
                      />
                      {errors.comment && touched.comment && (
                        <div className="text-red-500 text-sm mt-1">
                          {errors.comment}
                        </div>
                      )}
                    </div>

                    <div className="grid grid-cols-2 gap-2 mt-4">
                      <button
                        type="button"
                        onClick={() => {
                          toggleModal(false);
                          showToastModal({
                            title: "Intervention finalisée",
                            message:
                              "L'intervention a été finalisée avec succès.",
                            success: true,
                          });
                        }}
                        className="!rounded-md  !py-3 bg-white !text-[#0D44B1] !border-[#0D44B1] !border font-medium text-sm   uppercase"
                      >
                        Ignorer
                      </button>
                      <button
                        type="submit"
                        className="!rounded-md  !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm    uppercase"
                      >
                        Soumettre l'avis
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default AvisModal;
